module.exports = __webpack_public_path__ + "static/img/Rectangle 429.612ebaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Rectangle 429.png
// module id = AuSS
// module chunks = 41